import React, { useEffect, useState, useMemo } from "react";
import useStore from "../../useStore";
import { useToast } from "../../Contexts/Toast/toast.provider";
import Loader from "../Elements/Loader/Loader";
import { FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import BuscadorYFiltro from "../Layout/Buscador/BuscadorYFiltro";
import "./home.css";
/* import ImportFaltas from "../Sections/editEmpleado/EditFaltas/ImportFaltas/ImportFaltas"; */
import { useAuthentication } from "../../Hooks/useAuthentication";

export default function Home() {
  const { users, fetchEmpleados, loading, error, nextKey } = useStore();
  const showToast = useToast();
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [filterActivo, setFilterActivo] = useState("true");

  const { role } = useAuthentication();
  const isAdmin = role === "admin";

  useEffect(() => {
    if (error) {
      const message = error instanceof Error ? error.message : error?.error || "Error desconocido";
      showToast("error", message);
    }
  }, [error, showToast]);

  useEffect(() => {
    fetchEmpleados();
  }, [fetchEmpleados]);

  const cargarMas = () => {
    if (nextKey) fetchEmpleados(true, nextKey);
  };

  const handleAgregarUsuario = () => navigate("/createEmpleado");

  const quitarAcentos = (str) =>
    str ? str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() : "";

  const baseUsers = useMemo(
    () =>
      users
        .filter((u) => u.idEmpleado) // solo que tenga idEmpleado válido
        .map((u) => ({
          ...u,
          curp: u.datosPersonales?.curp || "",
          nombre: u.datosPersonales?.nombre || "",
          apellidoPaterno: u.datosPersonales?.apellidoPaterno || "",
          apellidoMaterno: u.datosPersonales?.apellidoMaterno || "",
          area: u.datosPuesto?.area || "",
          puesto: u.datosPuesto?.puesto || "",
          periodos: u.datosPuesto?.periodos || [],
        })),
    [users]
  );

  const getUltimoPeriodo = (emp) => {
    const p = Array.isArray(emp.periodos) ? emp.periodos : [];
    return p[p.length - 1] || null;
  };


  const empleadosFiltrados = useMemo(() => {
    let filtrados = baseUsers;

    // 1) Filtro por activo
    if (filterActivo !== "all") {
      const boolActivo = filterActivo === "true";
      filtrados = filtrados.filter((emp) => {
        const ultimo = getUltimoPeriodo(emp);
        return ultimo ? ultimo.activo === boolActivo : false;
      });
    }

    // 2) Búsqueda por tokens (AND) + soporte clave:valor + "frases exactas"
    const tokenRegex = /"([^"]+)"|(\S+)/g;
    const parseTokens = (q) => {
      const tokens = [];
      let m;
      while ((m = tokenRegex.exec(q))) {
        const raw = m[1] || m[2];
        const [k, ...rest] = raw.split(":");
        if (rest.length) {
          tokens.push({ type: "kv", key: k.toLowerCase(), value: quitarAcentos(rest.join(":")) });
        } else {
          tokens.push({ type: "word", value: quitarAcentos(raw) });
        }
      }
      return tokens;
    };

    const fieldMap = {
      nombre: (e) => e.nombre,
      apellidopaterno: (e) => e.apellidoPaterno,
      apellidomaterno: (e) => e.apellidoMaterno,
      apellidos: (e) => `${e.apellidoPaterno || ""} ${e.apellidoMaterno || ""}`.trim(),
      area: (e) => e.area,
      puesto: (e) => e.puesto,
      numeroempleado: (e) => String(e.numeroEmpleado || ""),
      ingreso: (e) => (getUltimoPeriodo(e)?.fechaIngreso || ""),
      egreso: (e) => (getUltimoPeriodo(e)?.fechaEgreso || "")
    };

    const fieldsForBag = [
      "nombre",
      "apellidopaterno",
      "apellidomaterno",
      "area",
      "puesto",
      "numeroempleado",
      "ingreso",
      "egreso"
    ];

    const buscar = quitarAcentos(search.trim());
    const tokens = buscar ? parseTokens(buscar) : [];
    if (!tokens.length) {
      return filtrados.sort((a, b) => a.numeroEmpleado - b.numeroEmpleado);
    }

    filtrados = filtrados.filter((emp) => {
      const bag = fieldsForBag
        .map((k) => quitarAcentos(fieldMap[k](emp) || ""))
        .join(" ");

      return tokens.every((t) => {
        if (t.type === "word") {
          return bag.includes(t.value);
        }
        if (t.type === "kv") {
          const getter = fieldMap[t.key];
          if (!getter) return false;
          const v = quitarAcentos(getter(emp) || "");
          return v.includes(t.value);
        }
        return true;
      });
    });

    return filtrados.sort((a, b) => a.numeroEmpleado - b.numeroEmpleado);
  }, [baseUsers, search, filterActivo]);


  const showEgresoColumn = useMemo(
    () =>
      empleadosFiltrados.some((emp) => {
        const ultimo = getUltimoPeriodo(emp);
        return ultimo && !ultimo.activo;
      }),
    [empleadosFiltrados]
  );

  if (loading) return <Loader />;
  if (error) {
    return (
      <div className="container py-5">
        <div className="alert alert-danger text-center">
          {error.message || "Error desconocido"}
        </div>
      </div>
    );
  }
  if (!baseUsers.length) {
    return (
      <div className="container py-5 d-flex flex-column align-items-center justify-content-center container-mh">
        <img
          src="https://cdn-icons-png.flaticon.com/512/7486/7486239.png"
          alt="Sin empleados"
          className="home-empty-img mb-3"
          style={{ width: 108, opacity: 0.85 }}
        />
        <div className="alert alert-warning text-center mb-4">
          No hay empleados registrados
        </div>
        {isAdmin && (
          <button
            onClick={handleAgregarUsuario}
            className="btn btn-primary btn-lg rounded-circle shadow btn-agregar-float"
            title="Agregar usuario"
          >
            <FaPlus size={26} />
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="container py-4 home-list-wrapper container-mh">
      {/*  {isAdmin && (
        <div className="d-flex justify-content-end mb-3">
          <ImportFaltas showToast={showToast} />
        </div>
      )} */}

      <div className="row align-items-end mb-3">
        <div className="col-12 col-md-6">
          <h2 className="mb-2 fw-bold text-primary-emphasis">Empleados</h2>
          <div className="text-muted mb-1" style={{ fontSize: 15 }}>
            Total: <b>{baseUsers.length}</b> &nbsp;|&nbsp; Mostrando: <b>{empleadosFiltrados.length}</b>
          </div>
        </div>
        <div className="col-12">
          {/* <BuscadorYFiltro
            search={search}
            setSearch={setSearch}
            filterActivo={filterActivo}
            setFilterActivo={setFilterActivo}
          /> */}

          <BuscadorYFiltro
            search={search}
            setSearch={setSearch}
            filterActivo={filterActivo}
            setFilterActivo={setFilterActivo}
            data={baseUsers} // usa tu arreglo ya mapeado
          />
        </div>
      </div>

      <div className="table-responsive shadow-sm rounded-4">
        <table className="table align-middle mb-0 table-hover">
          <thead className="table-light">
            <tr>
              <th>#</th>
              <th>Nombre</th>
              <th>Apellido Paterno</th>
              <th>Apellido Materno</th>
              <th>Área</th>
              <th>Puesto</th>
              <th>Ingreso</th>
              {showEgresoColumn && <th>Egreso</th>}
              <th>Activo</th>
            </tr>
          </thead>
          <tbody>
            {empleadosFiltrados.length === 0 ? (
              <tr>
                <td colSpan={10} style={{ textAlign: "center", color: "#888" }}>
                  No hay resultados
                </td>
              </tr>
            ) : (
              empleadosFiltrados.map((emp) => {
                const ultimo = getUltimoPeriodo(emp);
                return (
                  <tr key={emp.curp}>
                    <td
                      className="curp-link"
                      title="Ver detalle"
                      onClick={() => navigate(`/detalleEmpleado/${emp.idEmpleado}`)}
                      style={{ cursor: "pointer" }}
                    >
                      {emp.numeroEmpleado}
                    </td>
                    <td>{emp.nombre}</td>
                    <td>{emp.apellidoPaterno}</td>
                    <td>{emp.apellidoMaterno}</td>
                    <td>
                      <span className="badge badge-area">{emp.area}</span>
                    </td>
                    <td>{emp.puesto}</td>
                    <td>
                      {ultimo?.fechaIngreso ? (
                        <span className="badge badge-ingreso">{ultimo.fechaIngreso}</span>
                      ) : (
                        <span className="text-muted">Sin registro</span>
                      )}
                    </td>
                    {showEgresoColumn && (
                      <td>
                        {ultimo && !ultimo.activo && ultimo.fechaEgreso ? (
                          <span className="badge badge-egreso">{ultimo.fechaEgreso}</span>
                        ) : (
                          <span className="text-muted">-</span>
                        )}
                      </td>
                    )}

                    <td>
                      {ultimo?.activo ? (
                        <span className="badge badge-estado badge-activo">Activo</span>
                      ) : (
                        <span className="badge badge-estado badge-inactivo">Inactivo</span>
                      )}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {isAdmin && (
        <button
          onClick={handleAgregarUsuario}
          className="btn btn-primary btn-lg rounded-circle shadow btn-agregar-float"
          title="Agregar usuario"
        >
          <FaPlus size={24} />
        </button>
      )}

      {nextKey && (
        <button
          className="btn btn-outline-primary mt-3 w-100"
          onClick={cargarMas}
          disabled={loading}
        >
          {loading ? "Cargando..." : "Cargar más"}
        </button>
      )}
    </div>
  );
}
